export default "__VITE_ASSET__BYfmUHms__"